import Project from "./Project";

const Portfolio = () => {
  const projectLinks = [
    {
      image: "/images/responsive-multipage-blog-2a.png",
      text: "Task 2a",
      url: "https://dare47-week2a-project.netlify.app/",
    },
    {
      image: "/images/responsive-google-landing-2b.png",
      text: "Task 2b",
      url: "https://dare47-week2b-project.netlify.app/",
    },
    {
      image: "/images/multipage-portfolio-web-3.png",
      text: "Task 3",
      url: "https://dare47-week3-project.netlify.app/",
    },
    {
      image: "/images/todo-list-web-7.png",
      text: "Task 7",
      url: "https://dare47-week7-project.netlify.app/",
    },
    {
      image: "/images/responsive-weather-app-13a.png",
      text: "Task 13a",
      url: "https://dare47-week13a-project.netlify.app/",
    },
    {
      image: "/images/responsive-weather-app-13a.png",
      text: "Task 13a-react",
      url: "https://dare47-week13a-react.netlify.app/",
    },
  ];

  return (
    <div className="container-fluid py-4 px-4 bg-harsh">
      <h1 className="text-center text-orange-a d-none d-lg-block page-header">
        Portfolio
      </h1>

      <div className="row mobile mt-5">
        {projectLinks.map((task, index) => (
          <Project
            key={index}
            image={task.image}
            text={task.text}
            url={task.url}
          />
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
